"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TypeDropdown = exports.ExportedTypeDropdown = void 0;
var _react = _interopRequireWildcard(require("react"));
var _SelectBoxWrapper = require("../../utils/components/SelectBoxWrapper");
var _hooks = require("../../state/redux/hooks");
var _issueTypes = require("../../state/redux/ducks/issueTypes");
var _utils = require("./utils");
var _TypeDisplay = require("./TypeDisplay");
var _TypeDisplayWithHydration = require("./TypeDisplayWithHydration");
var _useTranslations = require("../../utils/i18n/useTranslations");
var _IssuesConsumer = require("../../IssuesConsumer");
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
var _featureFlags = require("../../utils/featureFlags");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const TypeDropdown = _ref => {
  let {
    onChange,
    selectedTypeId,
    defaultIsOpen,
    issueStatus,
    onClose,
    container,
    onClear,
    isClearable
  } = _ref;
  const {
    value: shouldUseNewDropdown
  } = (0, _featureFlags.useFeatureFlag)(_featureFlags.FeatureFlag.OutdatedComponentMigrationPhase2Batch3);
  const {
    T
  } = (0, _useTranslations.useTranslations)();
  // get input as grouped options for GroupedSelectBox
  const groupedTypes = (0, _hooks.useSelector)(_issueTypes.getActiveGroupedTypes);
  const groupedOptions = (0, _react.useMemo)(() => (0, _utils.getGroupedTypesAsOptions)(groupedTypes), [groupedTypes]);
  const optionRenderer = _react.default.useCallback(props => {
    return /*#__PURE__*/_react.default.createElement(_TypeDisplay.TypeDisplay, {
      stampCode: props.stampCode,
      status: issueStatus,
      title: props.label
    });
  }, [issueStatus]);
  const selectBoxWrapperValue = (0, _react.useMemo)(() => selectedTypeId ? {
    value: selectedTypeId
  } : null, [selectedTypeId]);
  const OldDropdown = () => /*#__PURE__*/_react.default.createElement(_SelectBoxWrapper.GroupedSelectBoxWrapper, {
    valueRenderer: _ref2 => {
      let {
        value
      } = _ref2;
      return /*#__PURE__*/_react.default.createElement(_TypeDisplayWithHydration.TypeDisplayWithHydration, {
        typeId: value,
        status: issueStatus
      });
    },
    optionRenderer: optionRenderer,
    value: selectBoxWrapperValue,
    options: groupedOptions,
    onChange: option => {
      if (option) {
        onChange(option.value);
      } else if (isClearable) {
        onClear && onClear();
      }
    },
    defaultIsOpen: defaultIsOpen,
    onClose: onClose,
    autoFocus: defaultIsOpen,
    searchable: true,
    clearable: isClearable,
    defaultInputValue: "",
    container: container,
    placeholder: T.translate("filterPanel.typePlaceholder"),
    "data-test-id": "type-dropdown"
  });
  const semanticIdentifier = "type-dropdown";
  const NewDropdown = () => {
    for (const group of groupedOptions) {
      group.items = group.options;
    }
    const getSelectedItem = () => {
      if (!selectedTypeId) return null;
      // new dropdown requires referential equality for the selected item
      for (const group of groupedOptions) {
        const selected = group.items.find(option => option.value === selectedTypeId);
        if (selected) {
          return selected;
        }
      }
      return null;
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const selectedItem = (0, _react.useMemo)(getSelectedItem, [selectedTypeId]);
    const {
      controlProps,
      menuProps,
      closeMenu
    } = (0, _alloyReactDropdown.useAutocomplete)({
      // TODO: make items property required, remove options property when migration is finalized
      // @ts-expect-error
      groupedItems: groupedOptions,
      selectedItem,
      defaultIsOpen,
      onSelectedItemChange: _ref3 => {
        let {
          selectedItem
        } = _ref3;
        if (selectedItem) {
          onChange(selectedItem.value);
        } else if (isClearable) {
          onClear && onClear();
        }
        closeMenu();
      },
      id: semanticIdentifier
    });
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.AutocompleteControl, _extends({}, controlProps, {
      placeholder: T.translate("filterPanel.typePlaceholder"),
      "data-testid": "".concat(semanticIdentifier, "-control"),
      renderItem: _ref4 => {
        let {
          selectedItem,
          isOpen
        } = _ref4;
        return isOpen ? null : /*#__PURE__*/_react.default.createElement(_TypeDisplayWithHydration.TypeDisplayWithHydration, {
          typeId: selectedItem.value,
          status: issueStatus
        });
      },
      style: {
        width: "100%"
      }
    })), /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.AutocompleteMenu, _extends({}, menuProps, {
      "data-testid": "".concat(semanticIdentifier, "-menu")
    }), menuProps.menuItems.map((itemOrGroupHeader, i) => (0, _alloyReactDropdown.isGroupHeader)(itemOrGroupHeader) ? /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MenuGroupHeader, {
      key: i,
      "data-testid": "".concat(semanticIdentifier, "-header-").concat(i)
    }, itemOrGroupHeader.label) : /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.MenuItem, _extends({
      key: i
    }, menuProps.getItemProps({
      item: itemOrGroupHeader
    }), {
      text: null,
      renderLeftComponent: () => /*#__PURE__*/_react.default.createElement(_TypeDisplay.TypeDisplay, {
        status: issueStatus,
        stampCode: itemOrGroupHeader.stampCode,
        title: itemOrGroupHeader.label
      })
    })))));
  };
  return shouldUseNewDropdown ? NewDropdown() : OldDropdown();
};
exports.TypeDropdown = TypeDropdown;
const ExportedTypeDropdown = exports.ExportedTypeDropdown = (0, _IssuesConsumer.withIssuesConsumer)(TypeDropdown);
//# sourceMappingURL=TypeDropdown.js.map